import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// EN-1196: which merge dialog or unmerge confirm is open. Client UI state only; merge state itself is React Query.
type State = {
    /** openedAt: the pathname the dialog first rendered on. The host remounts per page, so this is how a route change is seen. */
    dialog: { sourceId: string; targetId: string | null; openedAt?: string } | null;
    /** targetTime: the kept visit's time, from a caller that knows it (the Recycle Bin row). */
    unmerge: { mergeId: string; targetId: string; targetTime?: string } | null;
};
const initialState: State = { dialog: null, unmerge: null };

const mergeVisitsUiSlice = createSlice({
    name: "mergeVisitsUi",
    initialState,
    reducers: {
        openMergeDialog: (s, a: PayloadAction<{ sourceId: string; targetId?: string | null }>) => {
            s.dialog = { sourceId: a.payload.sourceId, targetId: a.payload.targetId ?? null };
        },
        markMergeDialogOpenedAt: (s, a: PayloadAction<string>) => {
            if (s.dialog && s.dialog.openedAt === undefined) s.dialog.openedAt = a.payload;
        },
        closeMergeDialog: (s) => {
            s.dialog = null;
        },
        openUnmergeConfirm: (s, a: PayloadAction<{ mergeId: string; targetId: string; targetTime?: string }>) => {
            s.unmerge = a.payload;
        },
        /** With a mergeId, closes the confirm only if it is still the one for that merge. */
        closeUnmergeConfirm: (s, a: PayloadAction<string | undefined>) => {
            if (a.payload === undefined || s.unmerge?.mergeId === a.payload) s.unmerge = null;
        },
    },
});

export const { openMergeDialog, markMergeDialogOpenedAt, closeMergeDialog, openUnmergeConfirm, closeUnmergeConfirm } =
    mergeVisitsUiSlice.actions;
export default mergeVisitsUiSlice.reducer;
